import {
  ExperimentNames,
  getEventDescription,
  getEventTitle,
  getFormattedFullLocation,
} from '@wix/wix-events-commons-statics'
import {useExperiments, useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {getEventDateInformation, isMultiDay} from '../../../../../../../../../../commons/selectors/event'
import {useWidgetHost, useWidgetState} from '../../../../../../../hooks/state-provider'
import {useVisibilityStyles} from '../../../../../../../hooks/use-visibility-styles'
import {getSelectedDate, getSelectedEventId} from '../../../../../../../selectors/calendar-layout'
import {getEventBadge, getEventById, getMultiDayText, getRibbonData} from '../../../../../../../selectors/events'
import {isMembersVisible, isRibbonVisible} from '../../../../../../../selectors/settings'
import {getShareFontSize} from '../../../../../../../utils/calendar'
import {EventBadge} from '../../../../../../event-badge'
import {LinkToPage} from '../../../../../../link-to-page'
import {Members} from '../../../../../../members'
import {Ribbon} from '../../../../../../ribbon'
import {SocialBar} from '../../../../../../social-bar'
import s from './content.scss'

export const EventDetailsContent = () => {
  const {t} = useTranslation()
  const {
    allBreakpoints: {isEventBadgeInEventInfo},
  } = useVisibilityStyles()
  const {experiments} = useExperiments()

  const host = useWidgetHost()
  const shareFontSize = parseInt(getShareFontSize({host}), 10)
  const selectedDate = useWidgetState(getSelectedDate)
  const selectedEventId = useWidgetState(getSelectedEventId)
  const event = useWidgetState(state => getEventById(state, selectedEventId))
  const showRibbon = useWidgetState(state => isRibbonVisible(state, event))
  const showMembers = useWidgetState(state => isMembersVisible(state, event))
  const multiDay = useWidgetState(state => isMultiDay(state, event))
  const multiDayText = useWidgetState(state => getMultiDayText(state, event.id, selectedDate, t))
  const fullDate = useWidgetState(state => getEventDateInformation(state, event.id).fullDate)
  const hasRibbon = useWidgetState(state => getRibbonData(state, event).visible)
  const eventBadge = useWidgetState(state => getEventBadge(state, event))
  const calendarRevampEnabled = experiments.enabled(ExperimentNames.CalendarRevamp)

  return (
    <div className={classNames(calendarRevampEnabled ? s.revamp : s.container)}>
      {isEventBadgeInEventInfo(eventBadge?.type, calendarRevampEnabled) && (
        <EventBadge event={event} className={classNames({[s.eventBadge]: !showRibbon || !hasRibbon})} />
      )}
      {showRibbon && <Ribbon event={event} className={s.ribbon} calendar />}
      {multiDay && <div className={s.multiDayTitle}>{multiDayText}</div>}
      <div data-hook="title" className={classNames({[s.title]: !calendarRevampEnabled})}>
        <LinkToPage event={event} className={classNames({[s.title]: calendarRevampEnabled})}>
          {getEventTitle(event)}
        </LinkToPage>
      </div>
      <div data-hook="date" className={s.fullDate}>
        {fullDate}
      </div>
      <div data-hook="location" className={classNames(s.location, {[s.opacity]: !calendarRevampEnabled})}>
        {getFormattedFullLocation(event)}
      </div>
      {showMembers && !calendarRevampEnabled && (
        <div data-hook="members" className={s.members}>
          <Members calendarLayout event={event} />
        </div>
      )}
      {getEventDescription(event) && (
        <div data-hook="description" className={s.description}>
          {getEventDescription(event)}
        </div>
      )}
      {showMembers && calendarRevampEnabled && (
        <div data-hook="members" className={s.members}>
          <Members calendarLayout event={event} />
        </div>
      )}
      <div data-hook="share" className={s.share}>
        {!calendarRevampEnabled && <div className={s.shareText}>{t('shareEventText')}</div>}
        <SocialBar row hideTitle t={t} spacing={7} event={event} iconFontSize={shareFontSize} newColors={false} />
      </div>
    </div>
  )
}
